export interface BatchWorkspaceShortcutCheatsheetBannerState {
  IsCheatsheetBannerClosed: boolean;
}

export const initialBatchWorkspaceShortcutCheatsheetBannerState: BatchWorkspaceShortcutCheatsheetBannerState = {
  IsCheatsheetBannerClosed: false,
};
